<template>
    <div class="login-wrapper-page">
        <div class="panel login-panel">
            <div class="login-panel-heading">
                <div class="login-logo"></div>
            </div>
            <div class="login-panel-body">
                <hr>
                <h5 class="text-muted text-center"><b>Your password has expired. Please create your new password. </b></h5>
                <div>
                    <form class="form-horizontal">
                        <div class="col-xs-11">
                            <input placeholder="Old Password" type="password" v-model="oldPassword">
                            <input placeholder="New Password" type="password" v-model="newPassword">
                            <input placeholder="Confirm New Password" type="password" v-model="confirmPassword">
                        </div>
                        <div class="col-xs-12" style="margin-bottom: 10px;">
                            <h5>Password Requirements</h5>
                            <ul class="pwhelp">
                                <li>Be at least 8 characters in length</li>
                                <li>Contain at least 1 lowercase and 1 uppercase letter</li>
                                <li>Contain at least 1 special character (!@#$%^&amp;*)</li>
                                <li>Contain at least 1 number (0-9)</li>
                            </ul>
                        </div>
                        <div class="form-group text-center">
                            <div class="col-xs-12">
                                <ac-button class="btn btn-sm btn-wide btn-blue" :action="updatePassword">
                                    UPDATE PASSWORD
                                </ac-button>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row">
                    <div class="col-xs-12">
                        <hr/>
                    </div>
                </div>
                <div class="col-md-7">
                    <p>
                        <small>
                            Your security and safety is important to us. All personal information is encrypted and safeguarded using the highest level of security standards.
                            To learn more, please view our <a href="https://www.myameriflex.net/Document/Viewer/b0fa2e6c69d14b70aa297454326302ce" target="_blank">Privacy Policy</a>.
                        </small>
                    </p>
                </div>
                <div class="col-md-5">
                    <p><img class="pull-right" src="../../../assets/images/hipaa-150.png"></p>
                </div>
            </div>
        </div> <!--close panel -->
    </div>
</template>

<script>
    import {api} from "../../../global/framework/api.js";
    import {notifications} from "../../../global/notifications.js";
    import {common} from "../../../global/common.js";

    export default {
        name: "PasswordExpired",
        data() {
            return {
                oldPassword: "",
                newPassword: "",
                confirmPassword: ""
            }
        },
        methods: {
            async updatePassword() {
                let result = await api.post('Account', 'UpdateExpiredPassword', {
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword,
                    confirmNewPassword: this.confirmPassword
                });
                if (result) {
                    common.logUserInWithToken(result.data.token, result.data.userId);
                }
            }
        }
    }
</script>

<style scoped>

</style>